// removed by extract-text-webpack-plugin
module.exports = {"img":"src-components-ModuleComponent-__lesson-module___img","video":"src-components-ModuleComponent-__lesson-module___video","subHeader":"src-components-ModuleComponent-__lesson-module___subHeader","lessonBodyWrapper":"src-components-ModuleComponent-__lesson-module___lessonBodyWrapper","linkIcons":"src-components-ModuleComponent-__lesson-module___linkIcons"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ModuleComponent/lesson.module.css
// module id = 212
// module chunks = 0